import { IconSpinner, IconSpinnerDefault } from '@components/design/Icons/index.js';
import React from 'react';

import { SpinnerWrap } from './spinner.styled.js';

const Spinner = ({ size, centered, containerHeight, margin, marginSvg, isHide, fillColor = '#fff', absoluteCenter }) => (
  <SpinnerWrap margin={margin} centered={centered} containerHeight={containerHeight} isHide={isHide} absoluteCenter={absoluteCenter}>
    {size === 'large' && <IconSpinner size='64px' fillColor={fillColor} marginSvg={marginSvg} />}
    {size === 'xs' && <IconSpinner size='16px' fillColor={fillColor} marginSvg={marginSvg} />}
    {size !== 'large' && size !== 'xs' && <IconSpinnerDefault fillColor={fillColor} marginSvg={marginSvg} />}
  </SpinnerWrap>
);

export default Spinner;
